import { DropdownMenuItem } from "@design-system/ui/dropdown-menu";
import { trans } from "@mongez/localization";
import { Smartphone } from "lucide-react";
import { useMobileAppPromotion } from "../hooks/use-mobile-app-promotion.hook";

/**
 * "Download the app" entry for the header user menu. Rendered only on
 * Android browsers when the tenant's effective `features.mobileApp` is on,
 * and stays available after the banner is dismissed.
 */
export function MobileAppMenuItem({ onSelect }: { onSelect?: () => void }) {
  const intentUrl = useMobileAppPromotion();

  if (!intentUrl) return null;

  return (
    <DropdownMenuItem asChild>
      <a
        href={intentUrl}
        className="flex w-full items-center gap-2 font-bold text-violet-700 dark:text-violet-300"
        onClick={onSelect}
      >
        <Smartphone className="mr-2 h-4 w-4" />
        <span>{trans("mobileApp.downloadApp")}</span>
      </a>
    </DropdownMenuItem>
  );
}
